import React, { useState, useEffect } from 'react';
import { Box, Modal, Typography, Divider } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { REGULAR_EXPRESSIONS } from '../../constants/index';
import { createService, deleteService } from '../../../../store/bonuses/actions';
import { CustomInput } from '../../../../components/CustomInput';
import { ReactComponent as CloseModalIcon } from '../../../../assets/images/close-modal.svg';
import { ReactComponent as Delete } from '../../../../assets/images/delete.svg';
import { search } from '../../../../utils/search';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  minHeight: 452,
  bgcolor: 'background.paper',
  boxShadow: '0px 12px 32px rgba(42, 70, 94, 0.03)',
  borderRadius: '12px',
  outline: 'none'
};

export const ModalService = ({
  showModal,
  setShowModal,
  services,
  companyId,
  updateServiceInForm,
  deleteServiceInform,
  permission,
  errorModal
}) => {
  const dispatch = useDispatch();
  const [serarch, setSerarch] = useState('');
  const [servicesCompany, setServicesCompany] = useState(services);
  const [addService, setAddService] = useState(false);
  const [newService, setNewService] = useState('');
  const [error, setError] = useState('');

  const createServiceHandler = () => {
    dispatch(createService({ name: newService, company_id: companyId })).then(res => {
        updateServiceInForm(res.data.data.instance);
      }
    );
  };

  const deleteServiceHandler = (id) =>
    dispatch(deleteService(id)).then(status => status ? deleteServiceInform(id) : errorModal());

  useEffect(() => {
    search(serarch, setServicesCompany, services, 'name');
  }, [serarch, services]);

  const handleNewServiceInput = (e) => {
    const input = e.target.value;
    if (input && !REGULAR_EXPRESSIONS.modal_and_service.test(input)) setError('Допустимые символы: 0-9, Ая-Яя, Aa-Zz, ", -, _, @.');
    else if (input.length > 100) setError('Максимум 100 символов');
    else if (input.length < 2) setError('Минимум 2 символа');
    else setError('');
    setNewService(input);
  };

  return (
    <Modal open={showModal} onClose={() => setShowModal(false)} data-testid="ModalReason">
      <Box sx={style}>
        <Box display="flex" justifyContent="space-between" alignItems="center" p="24px">
          <Typography variant="h5" fontWeight={500}>
            Акции
          </Typography>
          <CloseModalIcon cursor={'pointer'} onClick={() => setShowModal(false)} data-testid="CloseModal"/>
        </Box>
        <Divider />
        <Box p="24px">
          <CustomInput
            onChange={(e) => setSerarch(e.target.value)}
            value={serarch}
            type="search"
            sx={{ width: '100%' }}
            variant="outlined"
            size="small"
            placeholder="Поиск"
          />

          <Box
            display="flex"
            onClick={() => {
              setAddService(true);
            }}
            m="16px 0px"
            width="180px"
            sx={{ cursor: 'pointer' }}
            data-testid="AddService"
          >
            <AddIcon sx={{ color: 'primary.main' }} />
            <Typography color="primary.main">Добавить акцию</Typography>
          </Box>

          {addService && (
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <CustomInput
                data-testid="AddServiceInput"
                onChange={handleNewServiceInput}
                value={newService}
                sx={{ width: '350px' }}
                variant="outlined"
                size="small"
                placeholder="Введите название акции"
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    createServiceHandler();
                    setNewService('');
                    setAddService(false);
                  }
                }}
                error={error}
                helperText={error}
              />
              <Box>
                <CheckIcon
                  onClick={() => {
                    if (!error) {
                      createServiceHandler();
                      setNewService('');
                      setAddService(false);
                    }
                  }}
                  sx={{ marginRight: '15px' }}
                  cursor="pointer"
                  color="success"
                  data-testid="Check"
                />
                <CloseIcon
                  onClick={() => {
                    setNewService('');
                    setAddService(false);
                  }}
                  color="error"
                  cursor="pointer"
                  data-testid="CloseAddService"
                />
              </Box>
            </Box>
          )}

          <Box display="flex" flexDirection="column">
            {servicesCompany?.map((item) => (
              <Box
                display="flex"
                justifyContent="space-between"
                p="8px 0px"
                alignItems="center"
                key={item?.id}
                data-testid="serviceName"
                sx={{ wordBreak: 'break-word' }}
              >
                {item?.name}{' '}
                {permission && (
                  <span>
                    <Delete
                      cursor="pointer"
                      onClick={() => deleteServiceHandler(item?.id)}
                      data-testid="DeleteService"
                    />
                </span>
                )}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

ModalService.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  services: PropTypes.array,
  companyId: PropTypes.number,
  updateServiceInForm: PropTypes.func,
  deleteServiceInform: PropTypes.func,
  permission: PropTypes.bool,
  errorModal: PropTypes.func
};
